var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemplate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 112,
    viewBox: "0 0 196 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 112,
    rx: 4,
    fill: "var(--template-color)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 54,
    height: 96,
    rx: 1.63128,
    fill: "var(--template-bg)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 8,
    width: 118,
    height: 19,
    rx: 1.63128,
    fill: "var(--template-bg)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 33,
    width: 118,
    height: 54,
    rx: 1.63128,
    fill: "var(--template-bg)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 93,
    width: 26.5,
    height: 11,
    rx: 1.63128,
    fill: "var(--template-bg)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 100.5,
    y: 93,
    width: 26.5,
    height: 11,
    rx: 1.63128,
    fill: "var(--template-bg)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 93,
    width: 26.5,
    height: 11,
    rx: 1.63128,
    fill: "var(--template-bg)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 161.5,
    y: 93,
    width: 26.5,
    height: 11,
    rx: 1.63128,
    fill: "var(--template-bg)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplate);
export default __webpack_public_path__ + "static/media/template.658bb014a06417a59267435c980f992f.svg";
export { ForwardRef as ReactComponent };